export default __webpack_public_path__ + "static/media/legal-button.1f25332a.svg";